







































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Base64FileModel, FileContentModel } from '@shared/models/Common';
import { fileContentToFile } from '@shared/helpers/common.helper';

@Component({
  components: {},
})
export default class FilePicker extends Vue {
  @Prop({ required: false })
  public readonly fileContent?: FileContentModel;

  @Prop({ required: false })
  public readonly errorMessages?: string[];

  @Prop({ required: false })
  public readonly accept?: string;

  currentBlobUrl = '';

  showFileInput = true;

  $refs!: {
    fileInput: HTMLFormElement;
  };

  async mounted() {
    if (this.fileContent?.name !== undefined) {
      this.currentBlobUrl = await this.getFileUrl(this.fileContent);
      this.showFileInput = false;
    }
  }

  async getFileUrl(fileContent: FileContentModel) {
    const file = await fileContentToFile(fileContent);
    const url = URL.createObjectURL(file);
    return url;
  }

  onFileChange(file: File) {
    if (!file) {
      this.input({} as Base64FileModel);
    } else {
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      }).then((body: any) => {
        const pickedFileModel: Base64FileModel = {
          file,
          fileBase64: body,
        };
        this.input(pickedFileModel);
      });
    }
  }

  onFilePickClicked() {
    this.$refs.fileInput.click();
  }

  onRemove() {
    this.showFileInput = true;
    this.input({} as Base64FileModel);
  }

  @Emit()
  input(file: Base64FileModel) {
    return file;
  }
}
